import * as moment from 'moment';
const imagebaseurl = '';
let baseurl = process.env.BASE_URL;
const data = {
  baseurl: baseurl,
  production: true,
  imagebaseurl: imagebaseurl,
  authUrl: process.env.AUTH_URL,
  registrationUrl: process.env.REGISTRATION_URL,
  appointmentUrl: process.env.APPOINTMENT_URL,
  serviceIntegrationUrl: process.env.SERVICE_INTEGRATION_URL,
  questionnaireUrl: process.env.QUESTIONNAIRE_URL,
  adminUrl: process.env.ADMIN_URL,
  consultationUrl: process.env.CONSULTATION_URL,
  oscarDoctorId: baseurl === 'https://dev.quipohealth.com' ? 2 : 3,
};

//To connect to local server
// data.authUrl = `http://localhost:3333/authentication-api`;
// data.registrationUrl = `http://localhost:3333/registration-api`;
// data.appointmentUrl = `http://localhost:3333/appointment-api`;
// data.serviceIntegrationUrl = `http://localhost:3333/service-integrations-api`;
// data.questionnaireUrl = `http://localhost:3333/questionnaire-api`;
//  data.adminUrl = `http://localhost:3333/admin-api`;
// data.consultationUrl = `http://localhost:3333/consultation-api`;
export const environment = data;
export const calendarConfig = {
  format: 'yyyy-mm-dd',
  placeholder: 'YYYY-MM-DD',
  // max: moment(), //Set maximum valid date
  max: {
    year: moment().year(),
    month: moment().month() + 1, //Current month
    day: moment().date() + 1, //next day
  },
};
export const mapboxConfig = {
  accessToken:
    process.env.MAPBOX_TOKEN || 'pk.eyJ1IjoicXVpcG9oZWFsdGgiLCJhIjoiY2ttdW5wa3R0MGt4MjJvbzJjMThqMDFjeCJ9.ULd5LCGc2vl35l7utBFlug',
};
//local- sonia's account
// export const twilio = {
//   phoneno: '+1 330 441 4399',
//   appsid: 'AC23cd729eb52492a807abd4c3231ee885',
//   accesskey: '336fb2e44333a22736d7350172bbe14b',
// };
// local - navaneeth's account
// export const twilio = {
//   phoneno: '+12193793504',
//   appsid: 'AC128104bb8c8d020a52f694f7f3eae3c',
//   accesskey: '7913e1a3d727c6d32593a2b06d155f77',
// };

//local
export const supportAdminID = process.env.SUPPORT_ADMIN_ID;
export const twilio = {
  phoneno: '+17782008796',
  appsid: 'ACeb3c21cc52318810b907a2333541bb73',
  accesskey: 'c7755530b73d4de83e5ad067df729318',
};

export function liveOrUatEnvironment(){
  return !location?.origin?.includes('qa.') && !location?.origin?.includes('localhost');
}